import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "./ResultPage3d.scss";
import {
    selectPickResultDates,
    selectPickResultTime,
} from "../redux/3d_game_Slice/gameinfo3d";
import { SocketState } from "../context/SocketProvider";

function ResultPopup3d() {
    const navigate = useNavigate();
    const { socket } = SocketState();

    // Local states
    const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
    const [resultData, setResultData] = useState(null); // ✅ store socket response here
    const container = useRef(null);

    // Emit request when date changes
    useEffect(() => {
        if (!socket) return;
        const payload = {
            en: "PLAY_MATKA_RESULTS_HISTORY",
            data: { date: moment(fromDate, "YYYY-MM-DD").format("DD-MM-YYYY") },
        };
        // console.log("📤 Sending socket request:", payload);
        socket.emit("req", payload);
    }, [fromDate, socket]);

    // Listen for response
    useEffect(() => {
        if (!socket) return;

        const handleResponse = (response) => {
            if (response.en === "PLAY_MATKA_RESULTS_HISTORY") {
                // console.log("📥 Received socket response:", response.data);
                setResultData(response.data || {});
            }
        };

        socket.on("res", handleResponse);
        return () => socket.off("res", handleResponse);
    }, [socket]);

    return (
        <div className="myaccount_content">
            {/* Date Filter */}
            {/* Date Filter */}
            <div className="flex items-center">
                <div className="w-full flex flex-wrap gap-2 items-center px-2 py-2">
                    <div className="w-full sm:w-1/4 px-2">
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="from">
                                From
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                id="from"
                                type="date"
                                placeholder="from"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                max={moment().format("YYYY-MM-DD")}
                                min={"2023-04-01"}
                            />
                        </div>
                    </div>
                    {/* <button
                        onClick={() => navigate('/result')}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                    >
                        10/30/50
                    </button>
                    <button
                        onClick={() => navigate('/result1d')}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                    >
                        2D
                    </button> */}

                    {/* <button
                        onClick={() => navigate('/result3dchart')}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                    >
                        3D chart
                    </button>

                    <button
                        onClick={() => navigate('/result2d')}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                    >
                        4D
                    </button>
                    <button
                        onClick={() => navigate('/resultTitli')}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                    >
                        Titli
                    </button>
                    <button
                        onClick={() => navigate(-1)}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-6 rounded-lg"
                    >
                        Back
                    </button> */}
                </div>
            </div>

            {/* Table Section */}
            <div className="history_table_div overflow-y-auto pb-16" ref={container}>
                <table className="table table-borderless history_table">
                    <thead className="sticky top-0">
                        <tr>
                            <th className="text-center">TIME</th>
                            {/* Dynamically render columns based on response */}
                            {resultData?.dates?.length > 0 &&
                                resultData.dates.map((date, index) => (
                                    <th key={index} className="text-center">
                                        {date}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {resultData && Object.keys(resultData.time_result || {}).length > 0 ? (
                            Object.keys(resultData.time_result).map((timeKey, timeIndex) => (
                                <tr key={timeIndex} style={{ border: "3px solid #000" }}>
                                    <td className="text-center">{timeKey}</td>
                                    {resultData.time_result[timeKey].map((value, valueIndex) => (
                                        <td key={valueIndex}>
                                            <div className="result_his_line p-1 px-0">
                                                {value &&
                                                    (value.includes("&")
                                                        ? value.split("&").map((pair, idx) => {
                                                            const parts = pair.split("=");
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    className={`result_span_10_series text-center three_game_result_his${idx + 1}`}
                                                                >
                                                                    {parts[0]} - {parts[1] || ""}
                                                                </div>
                                                            );
                                                        })
                                                        : (() => {
                                                            const parts = value.split("=");
                                                            return (
                                                                <div className="result_span_10_series text-center">
                                                                    {parts[1] || value}
                                                                </div>
                                                            );
                                                        })())}
                                            </div>
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={8} className="text-center py-4 text-gray-500">
                                    No result found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ResultPopup3d;